import { render, staticRenderFns } from "./DeliveryAttach.vue?vue&type=template&id=70df6af0&"
import script from "./DeliveryAttach.vue?vue&type=script&lang=js&"
export * from "./DeliveryAttach.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAttach.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports